<template>
  <section class='about-is-different text-center'>
    <div class='contents mx-auto'>
      <h2 class='my-0 mx-lg-5 px-lg-5'>Here’s how the delivery of <span class='text-nowrap'>JORNAY PM</span> is&nbsp;different.</h2>

      <p class='dark-text my-5'>
        Taking medication for ADHD at night may seem unusual, but <span class='text-nowrap'>JORNAY PM</span> has a
        delayed release and unique
        absorption within the body. This allows for it to be taken at night for lasting symptom support
        throughout the day and into the early evening—without a short-acting booster.*
      </p>

      <div class='callout bg-gradient mx-auto'>
        <div class='callout__contents'>
          <p class='dark-text fw-bold my-0'>
            <span class='text-nowrap'>JORNAY PM</span> is intended for adults, adolescents, and children over the age
            of&nbsp;6.
          </p>
        </div>
      </div>

      <p class='main-text fw-extrabold mb-0'>
        <span class='text-nowrap'>JORNAY PM</span> is formulated with a well-studied medicine—called
        methylphenidate—that has been prescribed to people
        with ADHD for decades.
      </p>

      <p class='dark-text pt-lg-3 pb-lg-2'>Some of the most common side effects in both studies were trouble sleeping, nausea, decreased
        appetite, mood
        swings, restlessness, vomiting, and headache. Talk to your healthcare provider if you&nbsp;experience these or
        other
        side effects while taking <span class='text-nowrap'>JORNAY PM</span>.
      </p>

      <p class='dark-text mb-0'>*In clinical studies, children and adolescents were not given an afternoon booster.</p>
    </div>

  </section>
</template>

<script>
export default {
  name: 'AboutHowIsDifferent'
}
</script>
